/* eslint-disable no-useless-escape */
import { connect, createLocalTracks } from 'twilio-video'
import DetectRTC from 'detectrtc'
import ToktokdocLib from '@saas/lib/toktokdoc-lib/web'
import { cloneDeep } from 'lodash'
import { dispErrorMessage } from './MainActions'
import SlackNotifications from '../../utils/SlackNotifications'
import WebRtcConfigurator from '../../utils/WebRtcConfigurator'
import { VISIO_CONFIG_RELAY } from '../../utils/constants'
import {
    RESET_QUALITY_INDICATOR,
    DISPLAY_CALL_SUSPENDED_ALERT,
    CLOSE_CALL_SUSPENDED_ALERT,
    CURRENT_MEETING_SET,
    CURRENT_ROOM_SUCCESS,
    MEETING_CANNOT_START,
    DISPLAY_FEEDBACK,
    UPDATE_LOCALE_STARTED_DATE,
    CALL_SUSPENDED,
    FETCH_CLOSURE_BY_CARE_GIVER,
    FETCH_PHOTO_SESSION,
    ERROR_DURING_CALL_LEAVING,
    START_CALL_LEAVING,
    FEEDBACK_DIALOG_UPDATE_TITLE,
    FEEDBACK_DIALOG_UPDATE_CONTENT,
    MEETING_STARTED_CONSULTATION_SUCCESS,
    MEETING_STARTED_CONSULTATION_LEAVE,
    CURRENT_ROOM_CLOSED,
    CURRENT_MEETING_CLOSED,
    MEETING_TOTAL,
} from './types'
import { getPriceObjtArrFromRawList, pageview, formatPrice } from '../../utils/utils'
import {
    updateFeedbackDialogContent,
    updateFeedbackDialogTitle,
    displayFeedbackDialogContent,
    resetFeedbackDialog,
    updateFeedbackDialogError,
} from './FeedbackDialogAction'
import { entrerDemoModeTlc } from './DemoModeActions'
import { isDevicePresent } from '../../utils/twilioUtils'
import { setStreamingStetho, updateHeartBeatDate } from '../../api/consultation'
import config from '../../../../package.json'
import roomManager from '../../utils/RoomManager'
import { FetchedTransmissionFragment } from '../../api/queries/__generated__/transmissions.gql'
import { FetchedConsultationFragment } from '../../api/queries/__generated__/consultations.gql'
import { localStorageManager } from '../../utils/LocalStorageManager'

/**
 * @description function called when consultation left without finishing
 * Basic version that only closes.
 * @param {Object} room twilio video room
 * @param {Consultation} currentMeeting current consultation
 * @param {User} user required expert
 * @returns {Promise}
 */
export const leaveRoomWithoutFinishing =
    (room: any, currentMeeting: FetchedTransmissionFragment | FetchedConsultationFragment, visioConfig: string) =>
    async (dispatch: any, getState: any) => {
        dispatch(updateFeedbackDialogTitle('Interruption de la téléconsultation en cours'))
        dispatch(
            updateFeedbackDialogContent({
                progress: 0,
            }),
        )
        dispatch({
            type: START_CALL_LEAVING,
        })
        dispatch(displayFeedbackDialogContent(true))
        const consultId = currentMeeting.objectId
        console.log(
            `[CALLACTIONS-leaveRoomWithoutFinishing] leaving room without finishing| consultation id : ${consultId}`,
        )
        try {
            const state = getState()
            const { startedConsultationList } = state.meetings

            dispatch(
                updateFeedbackDialogContent({
                    subtitle: 'Finalisation',
                    progress: 99,
                }),
            )
            dispatch(
                updateFeedbackDialogContent({
                    subtitle: 'Finalisation',
                    progress: 100,
                }),
            )

            // disconnect from room
            switch (visioConfig) {
                case 'custom':
                    room.socket.disconnect(true)
                    break
                case 'twilio':
                default:
                    room.localParticipant.tracks.forEach((publication: any) => {
                        publication.track.detach()
                        // When passing localTracks down from the createLocalTracks(), we need to call detach as well as stop on each local tracks when disconnecting.
                        publication.track.stop()
                    })
                    room.disconnect()
                    break
            }

            // started TC already in store then add it to store started list
            if (!(currentMeeting.objectId in startedConsultationList)) {
                dispatch({
                    type: MEETING_STARTED_CONSULTATION_SUCCESS,
                    payload: {
                        startedConsultation: {
                            ...currentMeeting,
                        },
                        key: consultId,
                    },
                })
            }

            dispatch(resetFeedbackDialog())

            // call set isStreamingStetho false
            await setStreamingStetho(currentMeeting.objectId, false)
        } catch (error) {
            console.error(`[CALLACTIONS-leaveRoom] error catched | message : ${(error as any).message}`)
            dispatch(updateFeedbackDialogError(true))
            dispatch({
                type: ERROR_DURING_CALL_LEAVING,
            })
            throw new Error('CallActions-leaveRoomWithoutFinishing: could not leave room without finish call')
        }
    }

/**
 * @description begin to save invoice and summary when you click on save
 * @param {Consultation} currentMeeting current consultation
 * @param {Object} priceInfos
 * @param {string} note required expert summary
 * @param {Object} pInvoiceExtraInfosAndPrices cotation information
 */
export const startSaveInvoice =
    (currentMeeting: any, priceInfos: any, note: any, pInvoiceExtraInfosAndPrices: any) => async () => {
        try {
            const consultation = await ToktokdocLib.Consultation.instance(currentMeeting.objectId)

            await consultation.removeInvoice()

            if (priceInfos && pInvoiceExtraInfosAndPrices) {
                let pdsPrice = []
                if (
                    pInvoiceExtraInfosAndPrices.pdsPrices !== null &&
                    pInvoiceExtraInfosAndPrices.pdsPrices.length > 0 &&
                    currentMeeting.isPds
                ) {
                    pdsPrice = getPriceObjtArrFromRawList(pInvoiceExtraInfosAndPrices.pdsPrices)
                }
                let priceMajorations = []
                if (
                    pInvoiceExtraInfosAndPrices.priceMajorations !== null &&
                    pInvoiceExtraInfosAndPrices.priceMajorations.length > 0
                ) {
                    priceMajorations = getPriceObjtArrFromRawList(pInvoiceExtraInfosAndPrices.priceMajorations)
                }
                let priceMajorationsNight = []
                if (
                    pInvoiceExtraInfosAndPrices.priceMajorationsNight !== null &&
                    pInvoiceExtraInfosAndPrices.priceMajorationsNight.length > 0
                ) {
                    priceMajorationsNight = getPriceObjtArrFromRawList(
                        pInvoiceExtraInfosAndPrices.priceMajorationsNight,
                    )
                }
                let overChargePrice = 0
                if (
                    pInvoiceExtraInfosAndPrices.overChargePrice !== 0 &&
                    pInvoiceExtraInfosAndPrices.overChargePrice !== ''
                ) {
                    overChargePrice = Number(pInvoiceExtraInfosAndPrices.overChargePrice)
                }
                const totalBilledPrice = Number(pInvoiceExtraInfosAndPrices.totalBilledPrice)
                const { isConsultAld } = pInvoiceExtraInfosAndPrices
                const { cmucOrAcsOrAme } = pInvoiceExtraInfosAndPrices
                const { atOrMp } = pInvoiceExtraInfosAndPrices
                const { isCovid } = pInvoiceExtraInfosAndPrices
                const { isEmergency } = pInvoiceExtraInfosAndPrices
                const { invoiceNeedsMt } = pInvoiceExtraInfosAndPrices
                const { invoiceMt } = pInvoiceExtraInfosAndPrices
                const { cotationSummary } = pInvoiceExtraInfosAndPrices
                if (priceInfos.price > 0) {
                    console.log(
                        `[CALLACTIONS-leaveRoom] invoice creation | consultation id : ${currentMeeting.objectId}`,
                    )
                    await ToktokdocLib.Invoice.create(
                        consultation,
                        atOrMp,
                        cmucOrAcsOrAme,
                        isConsultAld,
                        priceInfos.careCode,
                        priceInfos.careLib,
                        invoiceNeedsMt,
                        invoiceMt,
                        overChargePrice,
                        priceInfos.price,
                        totalBilledPrice,
                        priceMajorations,
                        priceMajorationsNight,
                        pdsPrice,
                        isCovid,
                        isEmergency,
                        cotationSummary,
                    )
                }
            }
        } catch (error) {
            console.error(`[CALLACITONS-startSaveInvoice] error catched | message : ${(error as any).message}`)
        }
    }

/**
 * @description function called when consultation left
 * @param {Object} room twilio video room
 * @param {Consultation} currentMeeting current consultation
 * @param {User} user required expert
 * @param {string} patientId patient id
 * @returns {Promise}
 */
export const leaveRoom =
    (room: any, currentMeeting: FetchedConsultationFragment, user: any, visioConfig: string) =>
    async (dispatch: any, getState: any) => {
        dispatch(updateFeedbackDialogTitle('Finalisation de la téléconsultation en cours'))
        dispatch(
            updateFeedbackDialogContent({
                progress: 0,
            }),
        )

        dispatch({
            type: START_CALL_LEAVING,
        })
        dispatch(displayFeedbackDialogContent(true))
        const consultId = currentMeeting.objectId
        console.log(`[CALLACTIONS-leaveRoom] leaving room | consultation id : ${consultId}`)

        try {
            // TODO : deactivate listeners
            const state = getState()
            const { eventEmitterList } = state.meetings
            const { startedConsultationList } = state.meetings

            if (eventEmitterList[currentMeeting.objectId] !== undefined)
                eventEmitterList[currentMeeting.objectId].unsubscribe()

            const User = await ToktokdocLib.User.instance(user.objectId) // Ou getCurrent
            const TechnicalConfig = await User.getTechnicalConfig()
            const consultation = await ToktokdocLib.Consultation.instance(currentMeeting.objectId)

            const inputs: any = []
            room.localParticipant.tracks.forEach((track: any) => {
                const { kind, label } = track.track.mediaStreamTrack
                inputs.push({
                    kind,
                    label,
                })
            })

            const deviceInfo = {
                os: {
                    name: DetectRTC.osName,
                    version: DetectRTC.version,
                },
                browser: DetectRTC.browser,
                appVersion: config.version,
                inputs,
            }

            await consultation.setRequiredExpertInfos(deviceInfo)
            dispatch(
                updateFeedbackDialogContent({
                    subtitle: 'Finalisation',
                    progress: 99,
                }),
            )

            await consultation.endByDoctor()

            if (consultation.isDemo) {
                await consultation.removeInvoice()

                if (currentMeeting.isDemo) await consultation.endByCaregiver()
            }

            dispatch(
                updateFeedbackDialogContent({
                    subtitle: 'Finalisation',
                    progress: 100,
                }),
            )
            dispatch(entrerDemoModeTlc(false))

            switch (visioConfig) {
                case 'custom':
                    room.socket.disconnect(true)
                    break
                case 'twilio':
                default:
                    room.localParticipant.tracks.forEach((publication: any) => {
                        publication.track.detach()
                        // When passing localTracks down from the createLocalTracks(), we need to call detach as well as stop on each local tracks when disconnecting.
                        publication.track.stop()
                    })
                    room.disconnect()
                    break
            }
            pageview('Téléconsultation', 'Fin consultation')
            if (user.isReal == null || (user.isReal !== null && user.isReal === true)) {
                let totalBilledPriceStr = formatPrice(0)
                const invoice = await consultation.getInvoice()

                if (invoice) {
                    totalBilledPriceStr = formatPrice(invoice.totalBilledPrice)
                }

                SlackNotifications.TCEnd(consultation, totalBilledPriceStr)
            }

            // get new pending consultations
            const newTotalTlc = await User.getPendingConsultationCount(true)
            dispatch({
                type: MEETING_TOTAL,
                payload: newTotalTlc,
            })

            // if TC is in store then remove it
            if (currentMeeting.objectId in startedConsultationList) {
                dispatch({
                    type: MEETING_STARTED_CONSULTATION_LEAVE,
                    payload: consultId,
                })
            }

            dispatch(resetFeedbackDialog())
            if (
                (user.isReal === null || user.isReal === undefined || (user.isReal && user.isReal === true)) &&
                TechnicalConfig.isFeedbackHidden === false
            ) {
                dispatch({
                    type: DISPLAY_FEEDBACK,
                    payload: {
                        consultId: room.name,
                    },
                })
            }
        } catch (error) {
            console.error(`[CALLACTIONS-leaveRoom] error catched | message : ${(error as any).message}`)
            dispatch(updateFeedbackDialogError(true))
            dispatch({
                type: ERROR_DURING_CALL_LEAVING,
            })
            throw new Error('CallActions-leaveRoom: could not end call')
        }
    }

/**
 * @description Function called when consultation is canceled, this will not generate any documents or mails
 * @param {Object} room twilio video room
 * @param {Consultation} currentMeeting current consultation
 */
export const cancelConsultation =
    (room: any, currentMeeting: FetchedConsultationFragment, user: any, visioConfig: string) =>
    async (dispatch: any, getState: any) => {
        dispatch({
            type: FEEDBACK_DIALOG_UPDATE_TITLE,
            payload: {
                title: 'Abandon de la téléconsultation en cours',
            },
        })
        dispatch({
            type: FEEDBACK_DIALOG_UPDATE_CONTENT,
            payload: {
                progress: 0,
            },
        })
        dispatch({
            type: START_CALL_LEAVING,
        })
        dispatch(displayFeedbackDialogContent(true))
        const consultId = currentMeeting.objectId
        const User = await ToktokdocLib.User.instance(user.objectId) // Ou getCurrent
        console.log(`[CALLACTIONS-cancelConsultation] canceling room | consultation id : ${consultId}`)
        try {
            // clear events
            const state = getState()
            const { eventEmitterList } = state.meetings
            const { startedConsultationList } = state.meetings
            if (eventEmitterList[currentMeeting.objectId] !== undefined)
                eventEmitterList[currentMeeting.objectId].unsubscribe()
            // get consultation and cancel it
            const consultation = await ToktokdocLib.Consultation.instance(currentMeeting.objectId)
            await consultation.canceledByRequiredExpert()
            // clear and disconnect
            switch (visioConfig) {
                case 'custom':
                    room.socket.disconnect(true)
                    break
                case 'twilio':
                default:
                    room.localParticipant.tracks.forEach((publication: any) => {
                        publication.track.detach()
                        // When passing localTracks down from the createLocalTracks(), we need to call detach as well as stop on each local tracks when disconnecting.
                        publication.track.stop()
                    })
                    room.disconnect()
                    break
            }

            // get new pending consultations
            const newTotalTlc = await User.getPendingConsultationCount(true)
            dispatch({
                type: MEETING_TOTAL,
                payload: newTotalTlc,
            })

            dispatch({
                type: FEEDBACK_DIALOG_UPDATE_CONTENT,
                payload: {
                    progress: 100,
                },
            })
            dispatch(entrerDemoModeTlc(false))
            pageview('Téléconsultation', 'Fin consultation')
            dispatch(displayFeedbackDialogContent(false))
            dispatch(resetFeedbackDialog())

            // if TC is in store then remove it
            if (currentMeeting.objectId in startedConsultationList) {
                dispatch({
                    type: MEETING_STARTED_CONSULTATION_LEAVE,
                    payload: consultId,
                })
            }
        } catch (error) {
            console.error(`[CALLACTIONS-cancelConsultation] error catched | message : ${(error as any).message}`)
            dispatch({
                type: FEEDBACK_DIALOG_UPDATE_CONTENT,
                payload: {
                    subtitle: 'Une erreur est survenue, votre acte n’a pas été finalisé. Veuillez réessayer',
                    progress: 99,
                },
            })
            dispatch(updateFeedbackDialogError(true))
            dispatch({
                type: ERROR_DURING_CALL_LEAVING,
            })
            throw new Error('CallActions-cancelConsultation: could not cancel call')
        }
    }

/**
 * @async
 * @description Trying to connect video, if fail send error in a snackbar and slack
 * @param {*} dispatch
 * @param {string} token
 * @param {Consultation} meeting
 * @param {*} iceServersConfig
 * @param {User} user
 * @param {Boolean} isReconnect
 * @returns {void}
 */
const connectVideo = async (
    dispatch: any,
    token: any,
    meeting: any,
    iceServersConfig: any,
    user: any,
    isReconnect: any,
) => {
    pageview('Téléconsultation', 'Consultation en cours')
    // TODO: remove this when only tokapi will be used
    const objectId = meeting.objectId ? meeting.objectId : meeting.id
    const currentMeeting = {
        ...meeting,
        objectId,
    }
    const twilioConfig: Record<string, any> = {
        name: objectId,
        logLevel: 'warn',
    }
    if (iceServersConfig !== null) {
        twilioConfig.iceServers = iceServersConfig
        twilioConfig.iceTransportPolicy = 'relay'
    }
    try {
        // Local tracks configuration
        // Input tracks for local webcam and microphone are configured before room creation
        // Output track for speaker is configured after the room creation in Call component
        const videoDeviceId = localStorageManager.get('webcam')
        const audioDeviceId = localStorageManager.get('microphone')
        // We check first if device is really present on required expert computer
        const devices = await navigator.mediaDevices.enumerateDevices()
        let isVideoDevicePresent
        let isAudioDevicePresent = false
        if (videoDeviceId) isVideoDevicePresent = isDevicePresent(devices, videoDeviceId)
        if (audioDeviceId) isAudioDevicePresent = isDevicePresent(devices, audioDeviceId)
        const localTracksConfig = {
            video:
                videoDeviceId && isVideoDevicePresent
                    ? {
                          deviceId: videoDeviceId,
                      }
                    : true,
            audio:
                audioDeviceId && isAudioDevicePresent
                    ? {
                          deviceId: audioDeviceId,
                      }
                    : true,
        }
        const localTracks = await createLocalTracks(localTracksConfig)
        twilioConfig.tracks = localTracks
        twilioConfig.networkQuality = {
            local: 1,
            remote: 1,
        }
        const room = await connect(token, twilioConfig)
        dispatch({
            type: CURRENT_MEETING_SET,
            payload: currentMeeting,
        })
        dispatch({
            type: CURRENT_ROOM_SUCCESS,
        })
        roomManager.setRoom(room)

        if (!isReconnect) {
            const consultation = await ToktokdocLib.Consultation.findOne(objectId)
            await consultation.launch()
            dispatch({
                type: UPDATE_LOCALE_STARTED_DATE,
                payload: {
                    startedDate: new Date(),
                },
            })
            if (user.isReal === null || (user.isReal !== null && user.isReal === true))
                SlackNotifications.joinTC(consultation)
        }
        dispatch({
            type: CLOSE_CALL_SUSPENDED_ALERT,
        })
    } catch (error) {
        console.error(`[CALLACTIONS-connectVideo] ${error}`)
        if ((error as any).name !== null && (error as any).name === 'DevicesNotFoundError')
            dispErrorMessage(
                dispatch,
                '[Erreur matériel]: impossible de démarrer la téléconsultation.\nVérifiez que votre microphone ou votre webcam est branchée',
            )
        else if ((error as any).name !== null && (error as any).name === 'NotAllowedError')
            dispErrorMessage(
                dispatch,
                "[Erreur matériel]: impossible de démarrer la téléconsultation.\nVérifiez l'autorisation d'accès à votre microphone ou votre webcam.",
            )
        else if ((error as any).name !== null && (error as any).name === 'NotReadableError')
            dispErrorMessage(
                dispatch,
                '[Erreur matériel]: impossible de démarrer la téléconsultation.\nVérifiez que votre webcam ne soit pas déjà utilisé par une autre application et/ou que votre webcam soit compatible avec le navigateur.',
            )
        else if ((error as any).name !== null && (error as any).name === 'TwilioError')
            dispErrorMessage(
                dispatch,
                "[Erreur technique]: impossible de démarrer la téléconsultation.\nVérifiez l'état de votre connexion à Internet.",
            )
        else if ((error as any).name !== null && (error as any).name === 'AuthFailed')
            dispErrorMessage(
                dispatch,
                "[Erreur technique]: impossible de démarrer la téléconsultation.\nUne erreur d'authentication est survenue.",
            )
        else
            dispErrorMessage(
                dispatch,
                '[Erreur]: impossible de démarrer la téléconsultation.\nVeuillez effectuer un test de compatibilité depuis le menu utilisateur, situé en haut à droite.',
            )
        dispatch({
            type: MEETING_CANNOT_START,
        })
        if (user.isReal === null || (user.isReal !== null && user.isReal === true))
            SlackNotifications.joinTCFailed(currentMeeting, (error as any).name)
        // @ts-expect-error TS(2769) FIXME: No overload matches this call.
        throw new Error(error)
    }
}

/**
 * @description Start call
 * @param {Consultation} meeting
 * @param {User} user
 * @param {Boolean} isReconnect
 * @returns {void}
 */
export const startCall = (meetingData: any, user: any, isReconnect: any) => async (dispatch: any) => {
    try {
        const meeting = cloneDeep(meetingData)
        const User = await ToktokdocLib.User.findOne(user.objectId)
        const technicalConfig = await User.getTechnicalConfig()
        const { visioConfig } = technicalConfig

        // TODO: clean this when only tokapi will be used
        const objectId = meeting?.objectId ? meeting.objectId : meeting.id

        // set first heartbeat
        updateHeartBeatDate(objectId)

        // TODO: don't know the purpose of this
        // Check if we are in demo mode to recieve caregiver infos
        // if (meeting.isDemo) {
        // TODO: find a better way to identify caregiver in demo mode
        // const careGiverDemoObjectId = 'Z8jxvpD8SB'
        // const careGiver = await ToktokdocLib.User.findOne(careGiverDemoObjectId)
        // const careGiverTechnicalConfig = await careGiver.getTechnicalConfig()
        // if (careGiverTechnicalConfig.isDemo) meeting.careGiver.isDemo = true
        // }

        const url = `${window._env_.REACT_APP_HDS_HOST}/twilioToken?identity=${user.objectId}&room=${objectId}`
        const token = await ToktokdocLib.Utils.getSessionToken()
        const response = await fetch(url, {
            method: 'GET',
            headers: {
                'X-Session-Token': token,
            },
        })
        const twilioToken = await response.text()
        let iceServersConfig: any[] | undefined
        if (visioConfig !== null && visioConfig !== '') {
            console.warn(`we can use visioConfig ${visioConfig}`)
            if (visioConfig === VISIO_CONFIG_RELAY) {
                const webRtcConfig = new WebRtcConfigurator()
                const fetchConfigRes = await webRtcConfig.fetchRemoteConfig()
                if (fetchConfigRes !== null) {
                    console.warn('[CALLACTIONS-startCall] Successfully got STUN/TURN config for usage...')
                    const stunConfig = webRtcConfig.getStunServerConfig()
                    const turnConfig = webRtcConfig.getTurnSslServerConfig()
                    iceServersConfig = []
                    iceServersConfig.push(stunConfig)
                    iceServersConfig.push(turnConfig)
                } else console.warn('[CALLACTIONS-startCall] Error while fetching remote webRTC TURN config.')
                await connectVideo(dispatch, twilioToken, meeting, iceServersConfig, user, isReconnect)
                return
            }
        } else console.warn('[CALLACTIONS-startCall] Error no visioConfig found for this doctor')
        await connectVideo(dispatch, twilioToken, meeting, iceServersConfig, user, isReconnect)
    } catch (error) {
        console.error(`[CALLACTIONS-startCall] Error ${error}`)
        // @ts-expect-error TS(2769) FIXME: No overload matches this call.
        throw new Error(error)
    }
}

/**
 * @description resetQualityIndicator
 * @returns {void}
 */
export const resetQualityIndicator = () => (dispatch: any) =>
    dispatch({
        type: RESET_QUALITY_INDICATOR,
    })

/**
 * @description displayCallSuspendedAlert
 * @returns {void}
 */
export const displayCallSuspendedAlert = () => (dispatch: any) =>
    dispatch({
        type: DISPLAY_CALL_SUSPENDED_ALERT,
    })

/**
 * @description closeCallSuspendedAlert
 * @returns {void}
 */
export const closeCallSuspendedAlert = () => (dispatch: any) =>
    dispatch({
        type: CLOSE_CALL_SUSPENDED_ALERT,
    })

/**
 * @description suspendCallDueToOffline
 * @returns {void}
 */
export const suspendCallDueToOffline = () => (dispatch: any) =>
    dispatch({
        type: CALL_SUSPENDED,
    })

/**
 * @description fetchClosureByCareGiver
 * @param {*} originalData
 * @param {Object} obj
 * @param {*} dispatch
 * @param {*} state
 * @returns {Promise}
 */
export const fetchClosureByCareGiver = (originalData: any, obj: any, dispatch: any) =>
    new Promise((resolve, reject) => {
        try {
            const isClosedByCareGiver = obj.closedByCareGiver ? obj.closedByCareGiver : false
            if (originalData !== isClosedByCareGiver) {
                dispatch({
                    type: FETCH_CLOSURE_BY_CARE_GIVER,
                    payload: isClosedByCareGiver,
                })
            }
            // @ts-expect-error TS(2794) FIXME: Expected 1 arguments, but got 0. Did you forget to... Remove this comment to see the full error message
            resolve()
        } catch (error) {
            console.error(`[CALLACTIONS-fetchClosureByCareGiver] error: ${error}`)
            reject(error)
        }
    })

/**
 * @description fetchPhotoSession
 * @param {*} originalData
 * @param {Object} obj
 * @param {*} dispatch
 * @returns {Promise}
 */
export const fetchPhotoSession = (originalData: any, obj: any, dispatch: any) =>
    new Promise((resolve, reject) => {
        try {
            const isCareTakingPicture = !!obj.isCareTakingPicture
            if (originalData !== isCareTakingPicture) {
                console.log(`[CALLACTIONS-fetchPhotoSession] isCareTakingPicture changed to -> ${isCareTakingPicture}`)
                dispatch({
                    type: FETCH_PHOTO_SESSION,
                    payload: isCareTakingPicture,
                })
            }
            // @ts-expect-error TS(2794) FIXME: Expected 1 arguments, but got 0. Did you forget to... Remove this comment to see the full error message
            resolve()
        } catch (error) {
            console.error(`[CALLACTIONS-fetchPhotoSession] error: ${error}`)
            reject(error)
        }
    })

/**
 * @description clear current consultation
 * will clear current room
 * will clear current meeting
 *
 */
export const clearConsultation = () => (dispatch: any) => {
    dispatch({
        type: CURRENT_ROOM_CLOSED,
    })
    dispatch({
        type: CURRENT_MEETING_CLOSED,
    })
}
